import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLightest, onyxLight, onyxLightest} from '/theme/color/on.color';
import {
  chestnut,
  chestnutLightest,
  cyanBlue,
  denim,
  pine,
  pineLightest,
  shineWhite,
  yellow,
  yellowLightest,
} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    display: 'flex',
    width: '100%',
  },
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 20,
    zIndex: 1,
  },
  closeButtonIcon: {
    color: onyxLightest,
  },
  low: {
    borderColor: onyxLight,
    backgroundColor: cloudLightest,
  },
  info: {
    borderColor: denim,
    backgroundColor: cyanBlue,
  },
  important: {
    borderColor: yellow,
    backgroundColor: yellowLightest,
  },
  success: {
    borderColor: pine,
    backgroundColor: pineLightest,
  },
  error: {
    borderColor: chestnut,
    backgroundColor: chestnutLightest,
  },
  verticalBorder: {
    maxWidth: 4,
    borderWidth: 2,
    borderRadius: 8,
    height: '100%',
  },
  horizontalBorder: {
    borderTopWidth: 5,
  },
  verticalBase: {
    display: 'flex',
    flexDirection: 'row',
  },
  verticalContent: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  backgroundSucess: {
    backgroundColor: shineWhite,
  },
  text: {
    paddingLeft: indent,
    flex: 1,
  },
  verticalCloseButton: {
    paddingTop: 0,
    paddingRight: 16,
    paddingLeft: 12,
    alignSelf: 'flex-start',
  },
});
